/**
 * TYPE LABEL PARITY PATCH (2026-07-28 ruling): mirrors backend/utils/
 * document_generator.py's _PROCUREMENT_TYPE_DISPLAY_LABELS /
 * _procurement_type_label EXACTLY (same three labels, same strip+lower
 * normalization, same title-cased raw fallback). 4845e69 fixed the label
 * in the .docx only - every on-screen surface (RfpPreview's Requirements
 * Summary table, ParsedRequirementFields's Parsed Requirement/Parsed
 * Details cards, SmartIntakeWizard's extracted-fields table) still
 * rendered the raw enum ("mixed") until this patch. ONE shared helper so
 * the two sides can't drift again - if you change the label map here,
 * change document_generator.py's _PROCUREMENT_TYPE_DISPLAY_LABELS too
 * (and vice versa).
 *
 * Internal values (what's actually persisted/compared/branched on
 * elsewhere - WizardContext, LineItemsEditor classification, etc.) are
 * completely untouched by this - display only.
 */
import { pythonTitleCase } from './pythonTitleCase';

export const PROCUREMENT_TYPE_DISPLAY_LABELS = {
  goods: 'Goods',
  services: 'Services',
  mixed: 'Material & Services',
};

export const procurementTypeLabel = (procurementType) => {
  if (!procurementType) return '';
  const cleaned = String(procurementType).trim();
  if (!cleaned) return '';
  const known = PROCUREMENT_TYPE_DISPLAY_LABELS[cleaned.toLowerCase()];
  return known || pythonTitleCase(cleaned);
};
